import { useQuery } from '@tanstack/react-query';
import { inboxConversationService } from '@/services/conversation.service';
import { useInboxLocation } from '@/hooks/useInboxLocation';

/**
 * Unread inbox count for the nav badges (D-06, D-07). Scoped to the selected
 * inbox location, falling back to all accessible locations when the selection
 * is missing or not in the server-returned list.
 */
export function useInboxCount(enabled = true): number {
  const { locations, storedLocationId } = useInboxLocation({ enabled });
  const countLocationId =
    storedLocationId && locations.some((l) => l.id === storedLocationId)
      ? storedLocationId
      : undefined;

  const { data } = useQuery({
    queryKey: ['inbox', 'count', countLocationId ?? 'all'],
    queryFn: () => inboxConversationService.getUnreadCount(countLocationId),
    enabled,
    refetchInterval: 30_000,
    refetchIntervalInBackground: false,
    staleTime: 15_000,
  });
  return data?.count ?? 0;
}
